(() => {
/* Verhalten der Designstudie, uebertragen ins Theme.
   Dialoge, Einsatzort-Wechsel, mobiles Menue, Produktgalerie, Mengenfeld. */

const dsAlle = (s, w = document) => [...w.querySelectorAll(s)];
let dsAusloeser = null;

function dsOeffnen(dialog, ausloeser) {
  if (!dialog) return;
  dsAusloeser = ausloeser;
  dialog.showModal();
  const zu = dialog.querySelector('[data-ds-zu]');
  if (zu) zu.focus();
}

document.addEventListener('DOMContentLoaded', () => {
  dsAlle('[data-ds-zu]').forEach((b) =>
    b.addEventListener('click', () => b.closest('dialog')?.close())
  );
  dsAlle('dialog.ds-dialog').forEach((d) => {
    d.addEventListener('close', () => dsAusloeser?.focus());
    d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
  });

  dsAlle('[data-ds-bild]').forEach((knopf) =>
    knopf.addEventListener('click', () => {
      const dialog = document.querySelector('#ds-bilddialog');
      if (!dialog) return;
      const resolve = b => (b.dataset.dsZiel ? document.querySelector(b.dataset.dsZiel) : null) || b.querySelector('img') || b.closest('figure')?.querySelector('img');
      const ziel = resolve(knopf);
      if (!ziel || !(ziel.currentSrc || ziel.src)) return;
      const scroller = dialog.querySelector('[data-gallery-scroll]');
      const nav = dialog.querySelector('[data-gallery-thumbs]');
      const counter = dialog.querySelector('[data-gallery-count]');
      if (!scroller || !nav) return;
      const productThumbs = knopf.closest('.ds-pdp__galerie')?.querySelectorAll('[data-ds-daumen]');
      let selected = 0;
      let entries;
      if (productThumbs?.length) {
        entries = [...productThumbs].map((b,i) => {
          if(b.getAttribute('aria-pressed')==='true') selected=i;
          const thumb=b.querySelector('img');
          return {src:b.dataset.dsSrc,alt:b.dataset.dsAlt||'',thumb:thumb?.currentSrc||thumb?.src,width:thumb?.width,height:thumb?.height};
        });
      } else {
        const buttons = knopf.closest('.shopify-section')?.querySelectorAll('[data-ds-bild]') || [knopf];
        entries = [...buttons].map(b => {
          const img=resolve(b);
          return img ? {src:img.src||img.currentSrc,alt:img.alt,thumb:img.currentSrc||img.src,width:img.naturalWidth||img.width,height:img.naturalHeight||img.height,selected:b===knopf} : null;
        }).filter(Boolean);
        selected=Math.max(0,entries.findIndex(e=>e.selected));
      }
      scroller.replaceChildren();nav.replaceChildren();
      let observer,onScroll;
      const figures=entries.map((entry,i)=>{
        const figure=document.createElement('figure');
        const image=document.createElement('img');
        image.src=entry.src;image.alt=entry.alt;image.loading=i===selected?'eager':'lazy';image.decoding='async';
        if(entry.width&&entry.height){image.width=entry.width;image.height=entry.height;}
        figure.append(image);scroller.append(figure);
        const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',entry.alt||`${i+1} / ${entries.length}`);
        const thumb=document.createElement('img');thumb.src=entry.thumb||entry.src;thumb.alt='';b.append(thumb);nav.append(b);
        b.addEventListener('click',()=>figure.scrollIntoView({block:'start',behavior:'instant'}));
        return figure;
      });
      const mark=i=>{[...nav.children].forEach((b,n)=>b.setAttribute('aria-current',String(i===n)));counter.textContent=`${i+1} / ${entries.length}`};
      mark(selected);nav.hidden=entries.length<2;
      dsOeffnen(dialog,knopf);
      requestAnimationFrame(()=>{
        figures[selected]?.scrollIntoView({block:'start',behavior:'instant'});
        const update=()=>{
          /* Am Ende der Liste kann das letzte Bild nicht bis nach oben scrollen (mobil): dann gilt das letzte Bild */
          if(scroller.scrollHeight>scroller.clientHeight+2&&scroller.scrollTop>0&&scroller.scrollTop+scroller.clientHeight>=scroller.scrollHeight-2){mark(figures.length-1);return}
          const edge=scroller.getBoundingClientRect().top;
          let nearest=0,distance=Infinity;
          figures.forEach((f,i)=>{const rect=f.getBoundingClientRect();const d=rect.top<=edge+100&&rect.bottom>edge+100?0:Math.abs(rect.top-edge);if(d<distance){distance=d;nearest=i}});
          mark(nearest);
        };
        observer=new IntersectionObserver(update,{root:scroller,threshold:[0,.1,.25,.5,.75,1]});
        figures.forEach(f=>observer.observe(f));
        onScroll=()=>requestAnimationFrame(update);
        scroller.addEventListener('scroll',onScroll,{passive:true});
      });
      dialog.addEventListener('close',()=>{observer?.disconnect();if(onScroll)scroller.removeEventListener('scroll',onScroll)},{once:true});
    })
  );

  /* Einsatzorte wechseln */
  dsAlle('.ds-situations').forEach((section) => {
    const tabs = dsAlle('[data-ds-situation]', section);
    const label = section.querySelector('[data-ds-situation-label]');
    const frage = section.querySelector('[data-ds-situation-frage]');
    const text = section.querySelector('[data-ds-situation-text]');
    const link = section.querySelector('[data-ds-situation-link]');
    tabs.forEach((button) => button.addEventListener('click', () => {
      tabs.forEach((tab) => tab.setAttribute('aria-pressed', String(tab === button)));
      if (label) label.textContent = button.dataset.dsLabel || '';
      if (frage) frage.textContent = button.dataset.dsFrage || '';
      if (text) text.textContent = button.dataset.dsText || '';
      if (link && button.dataset.dsLink) link.setAttribute('href', button.dataset.dsLink);
    }));
  });

  /* Mobiles Menue */
  const menue = document.querySelector('#ds-menue');
  const oeffner = document.querySelector('[data-ds-menue-auf]');
  if (menue && oeffner) {
    oeffner.addEventListener('click', () => {
      menue.showModal();
      oeffner.setAttribute('aria-expanded', 'true');
      menue.querySelector('a, button')?.focus();
    });
    menue.addEventListener('close', () => {
      oeffner.setAttribute('aria-expanded', 'false');
      if (!menue.dataset.navigation) oeffner.focus({ preventScroll: true });
      delete menue.dataset.navigation;
    });
    menue.addEventListener('click', (e) => { if (e.target === menue) menue.close(); });
    dsAlle('[data-ds-menue-zu]', menue).forEach((b) => b.addEventListener('click', () => menue.close()));
    dsAlle('a', menue).forEach((a) => a.addEventListener('click', (event) => {
      const url = new URL(a.href, location.href);
      menue.dataset.navigation = 'true';
      menue.close();
      if (url.origin === location.origin && url.pathname === location.pathname && url.hash) {
        const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (target) {
          event.preventDefault();
          history.pushState(null, '', url.hash);
          requestAnimationFrame(() => {
            target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
            target.scrollIntoView({ behavior: 'instant', block: 'start' });
          });
        }
      }
    }));
  }

  /* Produktgalerie */
  const hauptbild = document.querySelector('[data-ds-hauptbild]');
  const daumen = dsAlle('[data-ds-daumen]');
  if (hauptbild && daumen.length) {
    daumen.forEach((b) =>
      b.addEventListener('click', () => {
        hauptbild.src = b.dataset.dsSrc;
        // Ohne passendes srcset wuerde der Browser weiter aus der alten Liste waehlen.
        if (b.dataset.dsSrcset) hauptbild.srcset = b.dataset.dsSrcset;
        else hauptbild.removeAttribute('srcset');
        hauptbild.alt = b.dataset.dsAlt || '';
        daumen.forEach((x) => x.setAttribute('aria-pressed', String(x === b)));
      })
    );
  }

  /* Mengenfeld am echten Warenkorbformular */
  dsAlle('[data-ds-menge]').forEach((gruppe) => {
    const feld = gruppe.querySelector('input');
    const anzeige = gruppe.querySelector('output');
    const minus = gruppe.querySelector('[data-ds-schritt="-1"]');
    const plus = gruppe.querySelector('[data-ds-schritt="1"]');
    const setze = (n) => {
      const wert = Math.max(1, Math.min(20, n));
      feld.value = wert;
      if (anzeige) anzeige.textContent = wert;
      if (minus) minus.disabled = wert === 1;
      if (plus) plus.disabled = wert === 20;
      feld.dispatchEvent(new Event('change', { bubbles: true }));
    };
    gruppe.querySelectorAll('[data-ds-schritt]').forEach((b) =>
      b.addEventListener('click', () => setze(parseInt(feld.value, 10) + Number(b.dataset.dsSchritt)))
    );
    setze(parseInt(feld.value, 10) || 1);
  });
});

})();
